import { AnalyticsBrowser } from "@segment/analytics-next";

import { AnalyticsEvents, AnalyticsTraits, IAnalyticsAdapter } from "../types";

export class SegmentAdapter implements IAnalyticsAdapter {
  private segment?: AnalyticsBrowser;
  private readonly writeKey?: string;

  constructor(writeKey?: string) {
    this.writeKey = writeKey;
  }

  initialize(): void {
    if (!this.writeKey) {
      console.warn(`VITE_SEGMENT_WRITE_KEY variable not provided, segment is not initialized`);
      return;
    }

    this.segment = new AnalyticsBrowser();
    this.segment.load({ writeKey: this.writeKey });
    console.log("Segment initialized");
  }

  trackEvent<Event extends keyof AnalyticsEvents>(
    event: Event,
    properties: AnalyticsEvents[Event],
  ): void {
    this.segment?.track(event, properties);
  }

  trackEventByName(eventName: string, properties?: Record<string, unknown>): void {
    this.segment?.track(eventName, properties);
  }

  trackPage(name: string): void {
    this.segment?.page(name);
  }

  identify(userId: string, traits: AnalyticsTraits): void {
    this.segment?.identify(userId, traits);
  }

  reset(): void {
    this.segment?.reset();
  }
}
